// TODO: REMOVE AFTER TEXTAREA REFACTOR
/* eslint-disable @typescript-eslint/ban-ts-comment */

import { SetStateAction, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { produce } from "immer";

import { Textarea } from "shared/components/Form/Textarea";
import { WizardData } from "shared/components/WizardNew/types";

import { SPLIT_TEST } from "shared/constants/split";
import { DEFAULT_MODE_WIZARD, SAFE_MODE_WIZARD } from "shared/constants/wizard";

import { WizardStore, WizardType } from "shared/context/WizardStoreContext";

import { simplyClick } from "shared/helpers/analytics";
import { isSplitTestRequired } from "shared/helpers/view";
import { setStepperState } from "shared/helpers/wizard";

import { useWizard, WizardStep } from "shared/hooks/useWizard";

import styles from "@platformAssets/components/Wizard.module.scss";

type Props = { wizardData: WizardData };

const WizardTextArea = ({ wizardData }: Props) => {
  const { pathname } = useLocation();

  const wizard = useWizard(wizardData);

  const step = pathname.replace("/", "") as WizardStep;

  const [wizardStore, setWizardStore] = useContext(WizardStore);

  const field = wizard[step]?.fieldArea;

  const textAreaValue = wizardStore.answers?.[step] ?? "";

  const { mode } = wizardData;
  const isSplitReducedWizardEnabled =
    mode === DEFAULT_MODE_WIZARD &&
    isSplitTestRequired(wizard.data, SPLIT_TEST.reducedWizard);

  const setAnalyticsEvent = () => {
    if (textAreaValue.length > 0) {
      wizard[step]?.analytics?.choose?.forEach((item: string) => {
        simplyClick(item, null, false);
      });
    }
  };

  const handleChange = (value: string) => {
    setWizardStore(
      produce(wizardStore, (wizard: WizardType) => {
        wizard.answers[step] = value;
      })
    );
  };

  useEffect(() => {
    if (mode === SAFE_MODE_WIZARD || isSplitReducedWizardEnabled) {
      setWizardStore(
        setStepperState(
          wizardStore,
          4,
          mode,
          isSplitReducedWizardEnabled
        ) as unknown as SetStateAction<WizardType>
      );
    }
  }, [mode, isSplitReducedWizardEnabled]);

  return (
    <div className={styles.textAreaWrapper}>
      <Textarea
        handleChange={handleChange}
        name={field?.name}
        placeholder={field?.placeholder}
        value={textAreaValue}
        rows={7}
        // @ts-expect-error
        // TODO: REMOVE AFTER Textfield REFACTOR
        onBlur={setAnalyticsEvent}
        limit={field?.limit}
      />
    </div>
  );
};

export { WizardTextArea };
